// // // import React, { useEffect, useState } from "react";
// // // import {
// // //     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
// // //     ResponsiveContainer, Cell
// // // } from "recharts";
// // // import {
// // //     ShoppingBag, Utensils, ShoppingCart
// // // } from "lucide-react";
// // // import axios from "axios";

// // // const Orders = ({ isMobile }) => {

// // //     const [ordersData, setOrdersData] = useState({
// // //         summary: { totalOrders: 0 },
// // //         byTimeSlot: []
// // //     });

// // //     const [loading, setLoading] = useState(false);

// // //     /* ---------------- API INTEGRATION ---------------- */
// // //     useEffect(() => {
// // //         const fetchOrders = async () => {
// // //             const vendorId = localStorage.getItem("vendorId");
// // //             const token = localStorage.getItem("authToken");

// // //             if (!vendorId || !token) {
// // //                 console.error("❌ Missing vendorId or authToken");
// // //                 return;
// // //             }

// // //             // ✅ Dates (last 7 days)
// // //             const toDate = new Date().toISOString().split("T")[0];
// // //             const fromDate = new Date(
// // //                 Date.now() - 30 * 24 * 60 * 60 * 1000
// // //             ).toISOString().split("T")[0];

// // //             setLoading(true);

// // //             try {
// // //                 const res = await axios.get(
// // //                     "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
// // //                     {
// // //                         params: {
// // //                             vendorId,
// // //                             fromDate,
// // //                             toDate
// // //                         },
// // //                         headers: {
// // //                             Authorization: `Bearer ${token}`
// // //                         }
// // //                     }
// // //                 );

// // //                 console.log("✅ Orders API Response:", res.data);

// // //                 const api = res.data?.data || res.data || {};

// // //                 const dailyStats = Array.isArray(api.dailyStats)
// // //                     ? api.dailyStats
// // //                     : [];

// // //                 const byTimeSlot = dailyStats.map((d, index) => ({
// // //                     label: new Date(d.date).toLocaleDateString("en-IN", {
// // //                         day: "2-digit",
// // //                         month: "short"
// // //                     }),
// // //                     orders: Number(d.orders ?? 0),
// // //                     color: index % 2 === 0 ? "#f59e0b" : "#10b981"
// // //                 }));

// // //                 setOrdersData({
// // //                     summary: {
// // //                         totalOrders: Number(api.totalOrders ?? 0)
// // //                     },
// // //                     byTimeSlot
// // //                 });

// // //             } catch (error) {
// // //                 console.error("❌ Orders API error:", error.response || error);
// // //                 setOrdersData({
// // //                     summary: { totalOrders: 0 },
// // //                     byTimeSlot: []
// // //                 });
// // //             } finally {
// // //                 setLoading(false);
// // //             }
// // //         };

// // //         fetchOrders();
// // //     }, []);

// // //     /* ---------------- SUMMARY CARDS ---------------- */
// // //     const OrdersSummaryCards = () => {
// // //         const orderTotal = ordersData.summary.totalOrders;

// // //         const orderCards = [
// // //             { title: 'Total Orders', value: orderTotal, icon: <ShoppingBag size={18} />, color: '#f59e0b' },
// // //             { title: 'Dine-in', value: Math.round(orderTotal * 0.45), icon: <Utensils size={18} />, color: '#10b981' },
// // //             { title: 'Takeaway', value: Math.round(orderTotal * 0.25), icon: <ShoppingBag size={18} />, color: '#3b82f6' },
// // //             { title: 'Delivery', value: Math.round(orderTotal * 0.30), icon: <ShoppingCart size={18} />, color: '#ef4444' }
// // //         ];

// // //         return (
// // //             <div style={{
// // //                 display: 'grid',
// // //                 gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
// // //                 gap: 12,
// // //                 marginBottom: 20
// // //             }}>
// // //                 {orderCards.map((card, index) => (
// // //                     <div key={index} style={{
// // //                         background: '#f8fafc',
// // //                         borderRadius: 14,
// // //                         padding: 16,
// // //                         border: '1px solid #e2e8f0',
// // //                         display: 'flex',
// // //                         justifyContent: 'space-between'
// // //                     }}>
// // //                         <div>
// // //                             <p style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>{card.title}</p>
// // //                             <p style={{ fontSize: 22, fontWeight: 800 }}>{card.value}</p>
// // //                         </div>
// // //                         <div style={{
// // //                             width: 40,
// // //                             height: 40,
// // //                             borderRadius: 10,
// // //                             background: `${card.color}20`,
// // //                             color: card.color,
// // //                             display: 'flex',
// // //                             alignItems: 'center',
// // //                             justifyContent: 'center'
// // //                         }}>
// // //                             {card.icon}
// // //                         </div>
// // //                     </div>
// // //                 ))}
// // //             </div>
// // //         );
// // //     };

// // //     /* ---------------- CHART ---------------- */
// // //     const OrdersAnalysis = () => {
// // //         if (loading) return <div style={{ padding: 40 }}>Loading orders...</div>;
// // //         if (!ordersData.byTimeSlot.length)
// // //             return <div style={{ padding: 40 }}>No order data available</div>;

// // //         return (
// // //             <div style={{
// // //                 background: 'white',
// // //                 borderRadius: 24,
// // //                 padding: isMobile ? 20 : 28,
// // //                 border: '1px solid #e2e8f0',
// // //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)'
// // //             }}>
// // //                 <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, marginBottom: 16 }}>
// // //                     Orders Analysis
// // //                 </h3>

// // //                 <div style={{ height: isMobile ? 280 : 360 }}>
// // //                     <ResponsiveContainer width="100%" height="100%">
// // //                         <BarChart data={ordersData.byTimeSlot}>
// // //                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// // //                             <XAxis dataKey="label" />
// // //                             <YAxis />
// // //                             <Tooltip />
// // //                             <Bar dataKey="orders" radius={[8, 8, 0, 0]}>
// // //                                 {ordersData.byTimeSlot.map((entry, index) => (
// // //                                     <Cell key={index} fill={entry.color} />
// // //                                 ))}
// // //                             </Bar>
// // //                         </BarChart>
// // //                     </ResponsiveContainer>
// // //                 </div>
// // //             </div>
// // //         );
// // //     };

// // //     return (
// // //         <>
// // //             <OrdersSummaryCards />
// // //             <OrdersAnalysis />
// // //         </>
// // //     );
// // // };

// // // export default Orders;





// // import React, { useEffect, useState } from "react";
// // import {
// //     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
// //     ResponsiveContainer, Cell
// // } from "recharts";
// // import {
// //     ShoppingBag, Utensils, ShoppingCart, Users
// // } from "lucide-react";
// // import axios from "axios";

// // const Orders = ({ isMobile }) => {

// //     const [ordersData, setOrdersData] = useState({
// //         summary: { 
// //             totalOrders: 0,
// //             dineInOrders: 0,
// //             takeawayOrders: 0,
// //             deliveryOrders: 0,
// //             tableDineInOrders: 0
// //         },
// //         byTimeSlot: []
// //     });

// //     const [loading, setLoading] = useState(false);

// //     /* ---------------- API INTEGRATION ---------------- */
// //     useEffect(() => {
// //         const fetchOrders = async () => {
// //             const vendorId = localStorage.getItem("vendorId");
// //             const token = localStorage.getItem("authToken");

// //             if (!vendorId || !token) {
// //                 console.error("❌ Missing vendorId or authToken");
// //                 return;
// //             }

// //             // ✅ Dates (last 30 days as in your API response)
// //             const toDate = new Date().toISOString().split("T")[0];
// //             const fromDate = new Date(
// //                 Date.now() - 30 * 24 * 60 * 60 * 1000
// //             ).toISOString().split("T")[0];

// //             setLoading(true);

// //             try {
// //                 const res = await axios.get(
// //                     "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
// //                     {
// //                         params: {
// //                             vendorId,
// //                             fromDate,
// //                             toDate
// //                         },
// //                         headers: {
// //                             Authorization: `Bearer ${token}`
// //                         }
// //                     }
// //                 );

// //                 console.log("✅ Orders API Response:", res.data);

// //                 const api = res.data?.data || res.data || {};

// //                 // Extract order type counts from orderTypeRevenueStats
// //                 const orderStats = api.orderTypeRevenueStats || {};

// //                 // Get actual counts from API
// //                 const dineInCount = orderStats.DINE_IN?.count || 0;
// //                 const takeawayCount = orderStats.TAKEAWAY?.count || 0;
// //                 const deliveryCount = orderStats.DELIVERY?.count || 0;
// //                 const tableDineInCount = orderStats.TABLE_DINE_IN?.count || 0;

// //                 const totalOrders = api.totalOrders || 0;

// //                 // Daily stats for chart
// //                 const dailyStats = Array.isArray(api.dailyStats)
// //                     ? api.dailyStats
// //                     : [];

// //                 const byTimeSlot = dailyStats.map((d, index) => ({
// //                     label: new Date(d.date).toLocaleDateString("en-IN", {
// //                         day: "2-digit",
// //                         month: "short"
// //                     }),
// //                     orders: Number(d.orders ?? 0),
// //                     revenue: Number(d.revenue ?? 0),
// //                     color: index % 2 === 0 ? "#f59e0b" : "#10b981"
// //                 }));

// //                 setOrdersData({
// //                     summary: {
// //                         totalOrders: totalOrders,
// //                         dineInOrders: dineInCount,
// //                         takeawayOrders: takeawayCount,
// //                         deliveryOrders: deliveryCount,
// //                         tableDineInOrders: tableDineInCount
// //                     },
// //                     byTimeSlot
// //                 });

// //             } catch (error) {
// //                 console.error("❌ Orders API error:", error.response || error);
// //                 setOrdersData({
// //                     summary: { 
// //                         totalOrders: 0,
// //                         dineInOrders: 0,
// //                         takeawayOrders: 0,
// //                         deliveryOrders: 0,
// //                         tableDineInOrders: 0
// //                     },
// //                     byTimeSlot: []
// //                 });
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchOrders();
// //     }, []);

// //     /* ---------------- SUMMARY CARDS ---------------- */
// //     const OrdersSummaryCards = () => {
// //         const { 
// //             totalOrders, 
// //             dineInOrders, 
// //             takeawayOrders, 
// //             deliveryOrders,
// //             tableDineInOrders 
// //         } = ordersData.summary;

// //         const orderCards = [
// //             { 
// //                 title: 'Total Orders', 
// //                 value: totalOrders, 
// //                 icon: <ShoppingBag size={18} />, 
// //                 color: '#f59e0b',
// //                 description: 'All orders in period'
// //             },
// //             { 
// //                 title: 'Dine-in', 
// //                 value: dineInOrders, 
// //                 icon: <Utensils size={18} />, 
// //                 color: '#10b981',
// //                 description: 'In-restaurant dining'
// //             },
// //             { 
// //                 title: 'Takeaway', 
// //                 value: takeawayOrders, 
// //                 icon: <ShoppingBag size={18} />, 
// //                 color: '#3b82f6',
// //                 description: 'Pickup orders'
// //             },
// //             { 
// //                 title: 'Delivery', 
// //                 value: deliveryOrders, 
// //                 icon: <ShoppingCart size={18} />, 
// //                 color: '#ef4444',
// //                 description: 'Home delivery'
// //             },
// //             { 
// //                 title: 'Table Dine-in', 
// //                 value: tableDineInOrders, 
// //                 icon: <Users size={18} />, 
// //                 color: '#8b5cf6',
// //                 description: 'Event/Table bookings'
// //             }
// //         ];

// //         return (
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(5,1fr)',
// //                 gap: 12,
// //                 marginBottom: 20
// //             }}>
// //                 {orderCards.map((card, index) => (
// //                     <div 
// //                         key={index} 
// //                         style={{
// //                             background: '#f8fafc',
// //                             borderRadius: 14,
// //                             padding: 16,
// //                             border: `1px solid ${card.color}20`,
// //                             display: 'flex',
// //                             justifyContent: 'space-between',
// //                             transition: 'all 0.2s ease',
// //                             cursor: 'help',
// //                             position: 'relative'
// //                         }}
// //                         title={card.description}
// //                         onMouseEnter={(e) => {
// //                             e.currentTarget.style.transform = 'translateY(-2px)';
// //                             e.currentTarget.style.boxShadow = `0 6px 16px ${card.color}20`;
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.transform = 'translateY(0)';
// //                             e.currentTarget.style.boxShadow = 'none';
// //                         }}
// //                     >
// //                         <div style={{ flex: 1 }}>
// //                             <p style={{ 
// //                                 fontSize: 12, 
// //                                 color: '#64748b', 
// //                                 fontWeight: 600,
// //                                 marginBottom: 4
// //                             }}>
// //                                 {card.title}
// //                             </p>
// //                             <p style={{ 
// //                                 fontSize: 22, 
// //                                 fontWeight: 800,
// //                                 color: card.color
// //                             }}>
// //                                 {card.value.toLocaleString()}
// //                             </p>

// //                             {/* Percentage indicator */}
// //                             {/* {card.title !== 'Total Orders' && totalOrders > 0 && (
// //                                 <p style={{
// //                                     fontSize: 11,
// //                                     color: '#94a3b8',
// //                                     marginTop: 4
// //                                 }}>
// //                                     {Math.round((card.value / totalOrders) * 100)}%
// //                                 </p>
// //                             )} */}
// //                         </div>
// //                         <div style={{
// //                             width: 40,
// //                             height: 40,
// //                             borderRadius: 10,
// //                             background: `${card.color}15`,
// //                             color: card.color,
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center'
// //                         }}>
// //                             {card.icon}
// //                         </div>
// //                     </div>
// //                 ))}
// //             </div>
// //         );
// //     };

// //     /* ---------------- CHART ---------------- */
// //     const OrdersAnalysis = () => {
// //         if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading orders...</div>;
// //         if (!ordersData.byTimeSlot.length)
// //             return <div style={{ padding: 40, textAlign: 'center' }}>No order data available</div>;

// //         return (
// //             <div style={{
// //                 background: 'white',
// //                 borderRadius: 24,
// //                 padding: isMobile ? 20 : 28,
// //                 border: '1px solid #e2e8f0',
// //                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
// //                 marginTop: 20
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     marginBottom: 20
// //                 }}>
// //                     <div>
// //                         <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800 }}>
// //                             Daily Orders Trend
// //                         </h3>
// //                         <p style={{ 
// //                             fontSize: 14, 
// //                             color: '#64748b',
// //                             marginTop: 4
// //                         }}>
// //                             Last 30 days
// //                         </p>
// //                     </div>

// //                     {/* Summary stats */}
// //                     <div style={{
// //                         display: 'flex',
// //                         gap: 16,
// //                         flexWrap: 'wrap'
// //                     }}>
// //                         <div style={{ textAlign: 'right' }}>
// //                             <p style={{ fontSize: 12, color: '#64748b' }}>Total Orders</p>
// //                             <p style={{ fontSize: 20, fontWeight: 700 }}>
// //                                 {ordersData.summary.totalOrders.toLocaleString()}
// //                             </p>
// //                         </div>
// //                         <div style={{ textAlign: 'right' }}>
// //                             <p style={{ fontSize: 12, color: '#64748b' }}>Avg Daily</p>
// //                             <p style={{ fontSize: 20, fontWeight: 700 }}>
// //                                 {ordersData.byTimeSlot.length > 0 
// //                                     ? Math.round(ordersData.byTimeSlot.reduce((sum, day) => sum + day.orders, 0) / ordersData.byTimeSlot.length)
// //                                     : 0
// //                                 }
// //                             </p>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 <div style={{ height: isMobile ? 280 : 360 }}>
// //                     <ResponsiveContainer width="100%" height="100%">
// //                         <BarChart data={ordersData.byTimeSlot}>
// //                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
// //                             <XAxis 
// //                                 dataKey="label" 
// //                                 tick={{ fontSize: 11 }}
// //                             />
// //                             <YAxis 
// //                                 tick={{ fontSize: 11 }}
// //                                 label={{ 
// //                                     value: 'Orders', 
// //                                     angle: -90, 
// //                                     position: 'insideLeft',
// //                                     fontSize: 12
// //                                 }}
// //                             />
// //                             <Tooltip 
// //                                 formatter={(value) => [`${value} orders`, 'Count']}
// //                                 labelFormatter={(label) => `Date: ${label}`}
// //                                 contentStyle={{ 
// //                                     borderRadius: 8,
// //                                     border: '1px solid #e2e8f0'
// //                                 }}
// //                             />
// //                             <Bar 
// //                                 dataKey="orders" 
// //                                 radius={[8, 8, 0, 0]}
// //                                 name="Orders"
// //                             >
// //                                 {ordersData.byTimeSlot.map((entry, index) => (
// //                                     <Cell key={index} fill={entry.color} />
// //                                 ))}
// //                             </Bar>
// //                         </BarChart>
// //                     </ResponsiveContainer>
// //                 </div>
// //             </div>
// //         );
// //     };

// //     return (
// //         <>
// //             <OrdersSummaryCards />
// //             <OrdersAnalysis />
// //         </>
// //     );
// // };

// // export default Orders;




// import React, { useEffect, useState } from "react";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//     ResponsiveContainer, Cell
// } from "recharts";
// import {
//     ShoppingBag, Utensils, ShoppingCart, Users
// } from "lucide-react";
// import axios from "axios";

// const Orders = ({ isMobile }) => {

//     const [ordersData, setOrdersData] = useState({
//         summary: {
//             totalOrders: 0,
//             dineInOrders: 0,
//             takeawayOrders: 0,
//             deliveryOrders: 0,
//             tableDineInOrders: 0
//         },
//         byTimeSlot: []
//     });

//     const [loading, setLoading] = useState(false);
//     const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//     // Add this useEffect to track window resize
//     useEffect(() => {
//         const handleResize = () => {
//             setWindowWidth(window.innerWidth);
//         };

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     /* ---------------- API INTEGRATION ---------------- */
//     useEffect(() => {
//         const fetchOrders = async () => {
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!vendorId || !token) {
//                 console.error("❌ Missing vendorId or authToken");
//                 return;
//             }

//             const toDate = new Date().toISOString().split("T")[0];
//             const fromDate = new Date(
//                 Date.now() - 30 * 24 * 60 * 60 * 1000
//             ).toISOString().split("T")[0];

//             setLoading(true);

//             try {
//                 const res = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
//                     {
//                         params: {
//                             vendorId,
//                             fromDate,
//                             toDate
//                         },
//                         headers: {
//                             Authorization: `Bearer ${token}`
//                         }
//                     }
//                 );


//                 const api = res.data?.data || res.data || {};
//                 const orderStats = api.orderTypeRevenueStats || {};

//                 const dineInCount = orderStats.DINE_IN?.count || 0;
//                 const takeawayCount = orderStats.TAKEAWAY?.count || 0;
//                 const deliveryCount = orderStats.DELIVERY?.count || 0;
//                 const tableDineInCount = orderStats.TABLE_DINE_IN?.count || 0;
//                 const totalOrders = api.totalOrders || 0;

//                 const dailyStats = Array.isArray(api.dailyStats)
//                     ? api.dailyStats
//                     : [];

//                 const byTimeSlot = dailyStats.map((d, index) => ({
//                     label: new Date(d.date).toLocaleDateString("en-IN", {
//                         day: "2-digit",
//                         month: "short"
//                     }),
//                     orders: Number(d.orders ?? 0),
//                     revenue: Number(d.revenue ?? 0),
//                     color: index % 2 === 0 ? "#f59e0b" : "#10b981"
//                 }));

//                 setOrdersData({
//                     summary: {
//                         totalOrders: totalOrders,
//                         dineInOrders: dineInCount,
//                         takeawayOrders: takeawayCount,
//                         deliveryOrders: deliveryCount,
//                         tableDineInOrders: tableDineInCount
//                     },
//                     byTimeSlot
//                 });

//             } catch (error) {
//                 console.error("❌ Orders API error:", error.response || error);
//                 setOrdersData({
//                     summary: {
//                         totalOrders: 0,
//                         dineInOrders: 0,
//                         takeawayOrders: 0,
//                         deliveryOrders: 0,
//                         tableDineInOrders: 0
//                     },
//                     byTimeSlot: []
//                 });
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOrders();
//     }, []);

//     /* ---------------- DYNAMIC ORDER CARDS ---------------- */
//     const OrdersSummaryCards = () => {
//         const {
//             totalOrders,
//             dineInOrders,
//             takeawayOrders,
//             deliveryOrders,
//             tableDineInOrders
//         } = ordersData.summary;

//         // Create array of cards with actual data only
//         const availableCards = [
//             {
//                 title: 'Total Orders',
//                 value: totalOrders,
//                 icon: <ShoppingBag size={18} />,
//                 color: '#f59e0b',
//                 description: 'All orders in period',
//                 showAlways: true // Always show total orders
//             },
//             {
//                 title: 'Dine-in',
//                 value: dineInOrders,
//                 icon: <Utensils size={18} />,
//                 color: '#10b981',
//                 description: 'In-restaurant dining',
//                 showAlways: false
//             },
//             {
//                 title: 'Takeaway',
//                 value: takeawayOrders,
//                 icon: <ShoppingBag size={18} />,
//                 color: '#3b82f6',
//                 description: 'Pickup orders',
//                 showAlways: false
//             },
//             {
//                 title: 'Delivery',
//                 value: deliveryOrders,
//                 icon: <ShoppingCart size={18} />,
//                 color: '#ef4444',
//                 description: 'Home delivery',
//                 showAlways: false
//             },
//             {
//                 title: 'Table Dine-in',
//                 value: tableDineInOrders,
//                 icon: <Users size={18} />,
//                 color: '#8b5cf6',
//                 description: 'Event/Table bookings',
//                 showAlways: false
//             }
//         ].filter(card => card.showAlways || card.value > 0);

//         // Determine grid columns based on number of cards
//         const cardCount = availableCards.length;

//         // Responsive grid logic
//         const getGridColumns = () => {
//             // Get screen width for more precise control
//             const screenWidth = window.innerWidth;

//             if (isMobile) {
//                 // Mobile: max 2 columns
//                 return cardCount <= 2 ? `repeat(${cardCount}, 1fr)` : 'repeat(2, 1fr)';
//             }

//             // Desktop/Laptop with different breakpoints
//             if (screenWidth < 1024) { // Smaller laptops (1024px - 768px)
//                 if (cardCount === 1) return '1fr';
//                 if (cardCount === 2) return 'repeat(2, 1fr)';
//                 if (cardCount === 3) return 'repeat(3, 1fr)';
//                 if (cardCount === 4) return 'repeat(2, 1fr)'; // 2x2 grid for 4 items
//                 if (cardCount === 5) return 'repeat(3, 1fr)'; // 3 columns, last row with 2 items
//                 return 'repeat(3, 1fr)';
//             } else if (screenWidth < 1280) { // Medium laptops (1280px - 1024px)
//                 if (cardCount === 1) return '1fr';
//                 if (cardCount === 2) return 'repeat(2, 1fr)';
//                 if (cardCount === 3) return 'repeat(3, 1fr)';
//                 if (cardCount === 4) return 'repeat(4, 1fr)';
//                 if (cardCount === 5) return 'repeat(3, 1fr)'; // 3 columns, last row with 2 items
//                 return 'repeat(3, 1fr)';
//             } else { // Large screens (> 1280px)
//                 if (cardCount === 1) return '1fr';
//                 if (cardCount === 2) return 'repeat(2, 1fr)';
//                 if (cardCount === 3) return 'repeat(3, 1fr)';
//                 if (cardCount === 4) return 'repeat(4, 1fr)';
//                 if (cardCount === 5) return 'repeat(5, 1fr)';
//                 return 'repeat(3, 1fr)';
//             }
//         };

//         // Card width constraints
//         const getCardStyles = () => {
//             const baseStyles = {
//                 background: '#f8fafc',
//                 borderRadius: 14,
//                 padding: '16px 12px',
//                 border: '1px solid #e2e8f0',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 transition: 'all 0.2s ease',
//                 cursor: 'help',
//                 position: 'relative',
//                 minHeight: '100px',
//                 flexShrink: 1,

//             };

//             // Constrain maximum width on desktop when few cards
//             if (!isMobile) {
//                 if (cardCount <= 2) {
//                     return {
//                         ...baseStyles,
//                         maxWidth: '280px',
//                         margin: '0 auto',
//                         minWidth: "250px"
//                     };
//                 } else if (cardCount === 3) {
//                     return {
//                         ...baseStyles,
//                         maxWidth: '220px'
//                     };
//                 } else if (cardCount === 4) {
//                     return {
//                         ...baseStyles,
//                         maxWidth: '200px'
//                     };
//                 }
//             }

//             return baseStyles;
//         };

//         const containerStyle = {
//             display: 'grid',
//             gridTemplateColumns: getGridColumns(),
//             gap: 12,
//             marginBottom: 20,
//             justifyContent: 'center',
//             alignItems: 'stretch'
//         };

//         return (
//             <div style={containerStyle}>
//                 {availableCards.map((card, index) => (
//                     <div
//                         key={index}
//                         style={getCardStyles()}
//                         title={card.description}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'translateY(-2px)';
//                             e.currentTarget.style.boxShadow = `0 6px 16px ${card.color}20`;
//                             e.currentTarget.style.borderColor = card.color;
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'translateY(0)';
//                             e.currentTarget.style.boxShadow = 'none';
//                             e.currentTarget.style.borderColor = '#e2e8f0';
//                         }}
//                     >
//                         <div style={{
//                             flex: 1,
//                             display: 'flex',
//                             flexDirection: 'column',
//                             justifyContent: 'space-between',
//                             minWidth: 0 // Prevent text overflow
//                         }}>
//                             <div>
//                                 <p style={{
//                                     fontSize: isMobile ? 11 : 12,
//                                     color: '#64748b',
//                                     fontWeight: 600,
//                                     marginBottom: 4,
//                                     whiteSpace: 'nowrap',
//                                     overflow: 'hidden',
//                                     textOverflow: 'ellipsis'
//                                 }}>
//                                     {card.title}
//                                 </p>
//                                 <p style={{
//                                     fontSize: isMobile ? 20 : 22,
//                                     fontWeight: 800,
//                                     color: card.color,
//                                     lineHeight: 1.2
//                                 }}>
//                                     {card.value.toLocaleString()}
//                                 </p>
//                             </div>

//                             {/* Percentage indicator */}
//                             {/* {card.title !== 'Total Orders' && totalOrders > 0 && (
//                                 <p style={{
//                                     fontSize: isMobile ? 10 : 11,
//                                     color: '#94a3b8',
//                                     marginTop: 6
//                                 }}>
//                                     {Math.round((card.value / totalOrders) * 100)}%
//                                 </p>
//                             )} */}
//                         </div>
//                         <div style={{
//                             width: isMobile ? 36 : 40,
//                             height: isMobile ? 36 : 40,
//                             borderRadius: 10,
//                             background: `${card.color}15`,
//                             color: card.color,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             flexShrink: 0,
//                             marginLeft: 8
//                         }}>
//                             {card.icon}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     /* ---------------- CHART ---------------- */
//     const OrdersAnalysis = () => {
//         if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading orders...</div>;
//         if (!ordersData.byTimeSlot.length)
//             return <div style={{ padding: 40, textAlign: 'center' }}>No order data available</div>;

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: 24,
//                 padding: isMobile ? 20 : 28,
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
//                 marginTop: 20
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: 20
//                 }}>
//                     <div>
//                         <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800 }}>
//                             Daily Orders Trend
//                         </h3>
//                         <p style={{
//                             fontSize: 14,
//                             color: '#64748b',
//                             marginTop: 4
//                         }}>
//                             Last 30 days
//                         </p>
//                     </div>

//                     <div style={{
//                         display: 'flex',
//                         gap: 16,
//                         flexWrap: 'wrap'
//                     }}>
//                         <div style={{ textAlign: 'right' }}>
//                             <p style={{ fontSize: 12, color: '#64748b' }}>Total Orders</p>
//                             <p style={{ fontSize: 20, fontWeight: 700 }}>
//                                 {ordersData.summary.totalOrders.toLocaleString()}
//                             </p>
//                         </div>
//                         <div style={{ textAlign: 'right' }}>
//                             <p style={{ fontSize: 12, color: '#64748b' }}>Avg Daily</p>
//                             <p style={{ fontSize: 20, fontWeight: 700 }}>
//                                 {ordersData.byTimeSlot.length > 0
//                                     ? Math.round(ordersData.byTimeSlot.reduce((sum, day) => sum + day.orders, 0) / ordersData.byTimeSlot.length)
//                                     : 0
//                                 }
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 <div style={{ height: isMobile ? 280 : 360 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={ordersData.byTimeSlot}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
//                             <XAxis
//                                 dataKey="label"
//                                 tick={{ fontSize: 11 }}
//                             />
//                             <YAxis
//                                 tick={{ fontSize: 11 }}
//                                 label={{
//                                     value: 'Orders',
//                                     angle: -90,
//                                     position: 'insideLeft',
//                                     fontSize: 12
//                                 }}
//                             />
//                             <Tooltip
//                                 formatter={(value) => [`${value} orders`, 'Count']}
//                                 labelFormatter={(label) => `Date: ${label}`}
//                                 contentStyle={{
//                                     borderRadius: 8,
//                                     border: '1px solid #e2e8f0'
//                                 }}
//                             />
//                             <Bar
//                                 dataKey="orders"
//                                 radius={[8, 8, 0, 0]}
//                                 name="Orders"
//                             >
//                                 {ordersData.byTimeSlot.map((entry, index) => (
//                                     <Cell key={index} fill={entry.color} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <OrdersSummaryCards />
//             <OrdersAnalysis />
//         </>
//     );
// };

// export default Orders;






import React, { useEffect, useState } from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ResponsiveContainer, Cell
} from "recharts";
import {
    ShoppingBag, Utensils, ShoppingCart, Users
} from "lucide-react";
import axios from "axios";

const Orders = ({ isMobile, timeRange, startDate, endDate }) => {

    const [ordersData, setOrdersData] = useState({
        summary: {
            totalOrders: 0,
            dineInOrders: 0,
            takeawayOrders: 0,
            deliveryOrders: 0,
            tableDineInOrders: 0
        },
        byTimeSlot: []
    });

    const [loading, setLoading] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Add this useEffect to track window resize
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    /* ---------------- API INTEGRATION ---------------- */
    /* ---------------- API INTEGRATION WITH FILTERS ---------------- */
    useEffect(() => {
        const fetchOrders = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) {
                console.error("❌ Missing vendorId or authToken");
                return;
            }

            // Determine date range based on filters
            let fromDate, toDate;

            // Default to last 30 days if no filters provided
            if (!timeRange || timeRange === 'monthly') {
                const today = new Date();
                toDate = today.toISOString().split("T")[0];
                const tempDate = new Date();
                tempDate.setMonth(tempDate.getMonth() - 1);
                fromDate = tempDate.toISOString().split("T")[0];
            }
            else if (timeRange === 'custom' && startDate && endDate) {
                // Custom date range from filter
                fromDate = startDate;
                toDate = endDate;
            } else if (timeRange === 'yearly') {
                const today = new Date();
                toDate = today.toISOString().split("T")[0];
                const tempDate = new Date();
                tempDate.setFullYear(tempDate.getFullYear() - 1);
                fromDate = tempDate.toISOString().split("T")[0];
            } else if (timeRange === 'weekly') {
                const today = new Date();
                toDate = today.toISOString().split("T")[0];
                const tempDate = new Date();
                tempDate.setDate(tempDate.getDate() - 7);
                fromDate = tempDate.toISOString().split("T")[0];
            } else if (timeRange === 'all') {
                // For "All Time", don't send date parameters
                fromDate = null;
                toDate = null;
            }

            setLoading(true);

            try {
                // Prepare API parameters
                const params = { vendorId };

                // Only add dates if they exist
                if (fromDate) params.fromDate = fromDate;
                if (toDate) params.toDate = toDate;


                const res = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/vendor/statistics/custom",
                    {
                        params: params,
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const api = res.data?.data || res.data || {};
                const orderStats = api.orderTypeRevenueStats || {};

                const dineInCount = orderStats.DINE_IN?.count || 0;
                const takeawayCount = orderStats.TAKEAWAY?.count || 0;
                const deliveryCount = orderStats.DELIVERY?.count || 0;
                const tableDineInCount = orderStats.TABLE_DINE_IN?.count || 0;
                const totalOrders = api.totalOrders || 0;

                const dailyStats = Array.isArray(api.dailyStats)
                    ? api.dailyStats
                    : [];

                const byTimeSlot = dailyStats.map((d, index) => ({
                    label: new Date(d.date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short"
                    }),
                    orders: Number(d.orders ?? 0),
                    revenue: Number(d.revenue ?? 0),
                    color: index % 2 === 0 ? "#f59e0b" : "#10b981"
                }));

                setOrdersData({
                    summary: {
                        totalOrders: totalOrders,
                        dineInOrders: dineInCount,
                        takeawayOrders: takeawayCount,
                        deliveryOrders: deliveryCount,
                        tableDineInOrders: tableDineInCount
                    },
                    byTimeSlot
                });

            } catch (error) {
                console.error("❌ Orders API error:", error.response || error);
                setOrdersData({
                    summary: {
                        totalOrders: 0,
                        dineInOrders: 0,
                        takeawayOrders: 0,
                        deliveryOrders: 0,
                        tableDineInOrders: 0
                    },
                    byTimeSlot: []
                });
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [timeRange, startDate, endDate]); // ✅ Re-fetch when filters change

    /* ---------------- DYNAMIC ORDER CARDS ---------------- */
    const OrdersSummaryCards = () => {
        const {
            totalOrders,
            dineInOrders,
            takeawayOrders,
            deliveryOrders,
            tableDineInOrders
        } = ordersData.summary;

        // Create array of cards with actual data only
        const availableCards = [
            {
                title: 'Orders',
                value: totalOrders,
                icon: <ShoppingBag size={18} />,
                color: '#f59e0b',
                description: 'All orders in period',
                showAlways: true // Always show total orders
            },
            {
                title: 'Dine-in',
                value: dineInOrders,
                icon: <Utensils size={18} />,
                color: '#10b981',
                description: 'In-restaurant dining',
                showAlways: false
            },
            {
                title: 'Takeaway',
                value: takeawayOrders,
                icon: <ShoppingBag size={18} />,
                color: '#3b82f6',
                description: 'Pickup orders',
                showAlways: false
            },
            {
                title: 'Delivery',
                value: deliveryOrders,
                icon: <ShoppingCart size={18} />,
                color: '#ef4444',
                description: 'Home delivery',
                showAlways: false
            },
            {
                title: 'Table Dine-in',
                value: tableDineInOrders,
                icon: <Users size={18} />,
                color: '#8b5cf6',
                description: 'Event/Table bookings',
                showAlways: false
            }
        ].filter(card => card.showAlways || card.value > 0);

        // Determine grid columns based on number of cards
        const cardCount = availableCards.length;

        // Responsive grid logic
        const getGridColumns = () => {
            // Get screen width for more precise control
            const screenWidth = window.innerWidth;

            if (isMobile) {
                // Mobile: max 2 columns
                return cardCount <= 2 ? `repeat(${cardCount}, 1fr)` : 'repeat(2, 1fr)';
            }

            // Desktop/Laptop with different breakpoints
            if (screenWidth < 1024) { // Smaller laptops (1024px - 768px)
                if (cardCount === 1) return '1fr';
                if (cardCount === 2) return 'repeat(2, 1fr)';
                if (cardCount === 3) return 'repeat(3, 1fr)';
                if (cardCount === 4) return 'repeat(2, 1fr)'; // 2x2 grid for 4 items
                if (cardCount === 5) return 'repeat(3, 1fr)'; // 3 columns, last row with 2 items
                return 'repeat(3, 1fr)';
            } else if (screenWidth < 1280) { // Medium laptops (1280px - 1024px)
                if (cardCount === 1) return '1fr';
                if (cardCount === 2) return 'repeat(2, 1fr)';
                if (cardCount === 3) return 'repeat(3, 1fr)';
                if (cardCount === 4) return 'repeat(4, 1fr)';
                if (cardCount === 5) return 'repeat(3, 1fr)'; // 3 columns, last row with 2 items
                return 'repeat(3, 1fr)';
            } else { // Large screens (> 1280px)
                if (cardCount === 1) return '1fr';
                if (cardCount === 2) return 'repeat(2, 1fr)';
                if (cardCount === 3) return 'repeat(3, 1fr)';
                if (cardCount === 4) return 'repeat(4, 1fr)';
                if (cardCount === 5) return 'repeat(5, 1fr)';
                return 'repeat(3, 1fr)';
            }
        };

        // Card width constraints
        const getCardStyles = () => {
            const baseStyles = {
                background: '#f8fafc',
                borderRadius: 14,
                padding: '16px 12px',
                border: '1px solid #e2e8f0',
                display: 'flex',
                justifyContent: 'space-between',
                transition: 'all 0.2s ease',
                cursor: 'help',
                position: 'relative',
                minHeight: '100px',
                flexShrink: 1,

            };

            // Constrain maximum width on desktop when few cards
            if (!isMobile) {
                if (cardCount <= 2) {
                    return {
                        ...baseStyles,
                        maxWidth: '280px',
                        margin: '0 auto',
                        minWidth: "250px"
                    };
                } else if (cardCount === 3) {
                    return {
                        ...baseStyles,
                        maxWidth: '220px'
                    };
                } else if (cardCount === 4) {
                    return {
                        ...baseStyles,
                        maxWidth: '200px'
                    };
                }
            }

            return baseStyles;
        };

        const containerStyle = {
            display: 'grid',
            gridTemplateColumns: getGridColumns(),
            gap: 12,
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'stretch'
        };

        return (
            <div style={containerStyle}>
                {availableCards.map((card, index) => (
                    <div
                        key={index}
                        style={getCardStyles()}
                        title={card.description}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = `0 6px 16px ${card.color}20`;
                            e.currentTarget.style.borderColor = card.color;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.borderColor = '#e2e8f0';
                        }}
                    >
                        <div style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            minWidth: 0 // Prevent text overflow
                        }}>
                            <div>
                                <p style={{
                                    fontSize: isMobile ? 11 : 12,
                                    color: '#64748b',
                                    fontWeight: 600,
                                    marginBottom: 4,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {card.title}
                                </p>
                                <p style={{
                                    fontSize: isMobile ? 20 : 22,
                                    fontWeight: 800,
                                    color: card.color,
                                    lineHeight: 1.2
                                }}>
                                    {card.value.toLocaleString()}
                                </p>
                            </div>

                            {/* Percentage indicator */}
                            {/* {card.title !== 'Total Orders' && totalOrders > 0 && (
                                <p style={{
                                    fontSize: isMobile ? 10 : 11,
                                    color: '#94a3b8',
                                    marginTop: 6
                                }}>
                                    {Math.round((card.value / totalOrders) * 100)}%
                                </p>
                            )} */}
                        </div>
                        <div style={{
                            width: isMobile ? 36 : 40,
                            height: isMobile ? 36 : 40,
                            borderRadius: 10,
                            background: `${card.color}15`,
                            color: card.color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            marginLeft: 8
                        }}>
                            {card.icon}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    /* ---------------- CHART ---------------- */
    const OrdersAnalysis = () => {
        if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading orders...</div>;
        if (!ordersData.byTimeSlot.length)
            return <div style={{ padding: 40, textAlign: 'center' }}>No order data available</div>;

        // Determine date range text based on filter
        let dateRangeText = "Last 30 days"; // Default
        if (timeRange === 'custom' && startDate && endDate) {
            dateRangeText = `${formatDate(startDate)} to ${formatDate(endDate)}`;
        } else if (timeRange === 'yearly') {
            dateRangeText = "Last 1 Year";
        } else if (timeRange === 'weekly') {
            dateRangeText = "Last 7 Days";
        } else if (timeRange === 'all') {
            dateRangeText = "All Time";
        }

        return (
            <div style={{
                background: 'white',
                borderRadius: 24,
                padding: isMobile ? 20 : 28,
                border: '1px solid #e2e8f0',
                boxShadow: '0 12px 32px rgba(0,0,0,0.05)',
                marginTop: 20
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 20
                }}>
                    <div>
                        <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800 }}>
                            Daily Orders Trend
                        </h3>
                        <p style={{
                            fontSize: 14,
                            color: '#64748b',
                            marginTop: 4
                        }}>
                            {dateRangeText} {/* ← This will now show the filter */}
                        </p>
                    </div>

                    <div style={{
                        display: 'flex',
                        gap: 16,
                        flexWrap: 'wrap'
                    }}>
                        <div style={{ textAlign: 'right' }}>
                            <p style={{ fontSize: 12, color: '#64748b' }}>Orders</p>
                            <p style={{ fontSize: 20, fontWeight: 700 }}>
                                {ordersData.summary.totalOrders.toLocaleString()}
                            </p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <p style={{ fontSize: 12, color: '#64748b' }}>Avg Daily</p>
                            <p style={{ fontSize: 20, fontWeight: 700 }}>
                                {ordersData.byTimeSlot.length > 0
                                    ? Math.round(ordersData.byTimeSlot.reduce((sum, day) => sum + day.orders, 0) / ordersData.byTimeSlot.length)
                                    : 0
                                }
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{ height: isMobile ? 280 : 360 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={ordersData.byTimeSlot}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
                            <XAxis
                                dataKey="label"
                                tick={{ fontSize: 11 }}
                            />
                            <YAxis
                                tick={{ fontSize: 11 }}
                                label={{
                                    value: 'Orders',
                                    angle: -90,
                                    position: 'insideLeft',
                                    fontSize: 12
                                }}
                            />
                            <Tooltip
                                formatter={(value) => [`${value} orders`, 'Count']}
                                labelFormatter={(label) => `Date: ${label}`}
                                contentStyle={{
                                    borderRadius: 8,
                                    border: '1px solid #e2e8f0'
                                }}
                            />
                            <Bar
                                dataKey="orders"
                                radius={[8, 8, 0, 0]}
                                name="Orders"
                            >
                                {ordersData.byTimeSlot.map((entry, index) => (
                                    <Cell key={index} fill={entry.color} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    };

    return (
        <>
            <OrdersSummaryCards />
            <OrdersAnalysis />
        </>
    );
};

export default Orders;